import { infer as Infer, z } from 'zod';

export const directoryCreateSchema = z.object({
  name: z.string().min(1, 'Nazwa folderu jest wymagana'),
  parentDirId: z.string().min(1),
});

export type DirectoryCreateSchema = Infer<typeof directoryCreateSchema>;
